<script>
  export default {
    name: 'ZkRadioButton',

    props: {
      label: {
        type: [String, Number],
        required: true
      },
      disabled: Boolean,
      name: String
    },
    data() {
      return {
        size: this.$parent.size
      };
    },
    computed: {
      value: {
        get() {
          return this.$parent.value;
        },
        set(newValue) {
          this.$parent.$emit('input', newValue);
        }
      }
    }
  };
</script>

<template>
  <label
    class="zk-radio-button"
    :class="[
      size ? 'zk-radio-button--' + size : '',
      { 'is-active': value === label }
    ]"
  >
    <input
      class="zk-radio-button__orig-radio"
      :value="label"
      type="radio"
      v-model="value"
      :name="name"
      :disabled="disabled">
    <span class="zk-radio-button__inner">
      <slot></slot>
      <template v-if="!$slots.default">{{label}}</template>
    </span>
  </label>
</template>



// WEBPACK FOOTER //
// radio-button.vue?01890b7d